import { TEmployeeRenewVisaDocumentGroup } from "@/api/entities/employee-renew-visa-document-group.entity";
import { TEmployeeRenewVisaDocumentStepGroup } from "@/api/entities/employee-renew-visa-document-step-group.entity";

export const findRenewVisaDocumentStepGroup = (
  data: TEmployeeRenewVisaDocumentGroup | undefined,
  stepKey: string,
): TEmployeeRenewVisaDocumentStepGroup | undefined => {
  if (!data) return undefined;
  return data.renewVisaDocumentStepGroups.find((step) => step.masterDocumentStep.stepKey === stepKey);
};
